var map = {
	"./burger.png": 2192,
	"./catalog.png": 9554,
	"./chat.png": 5917,
	"./close.png": 355,
	"./eye.png": 4928,
	"./invisible.png": 1158,
	"./logout.png": 3613,
	"./main.png": 1736,
	"./phone.png": 7147,
	"./plus.png": 8815,
	"./refresh.png": 6094,
	"./script.png": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8796;